// extracted by mini-css-extract-plugin
export default {"container":"Iq-z","brandName":"Jq-z","productName":"Kq-z","productNamePdpEnhancements":"Lq-z","breakLongProductName":"Mq-z"};